import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import PuffLoader from 'react-spinners/PuffLoader';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'reset' | 'submit';
  inline?: boolean;
  transparent?: boolean;
  style?: any;
}

export default function ButtonComponent({
  size,
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  variant = 'secondary',
  type = 'button',
  inline = false,
  transparent = false,
  style,
}: Props): JSX.Element {
  const override = {
    display: 'block',
    margin: '0 auto',
  };

  const color = '#ffffff';
  return (
    <StyledButton
      className={`ak-bg-btn ${inline === true ? 'mb-2' : ''}`}
      disabled={disabled || isSubmitting}
      variant={variant}
      transparent={transparent}
      type={type}
      active={active}
      size={size}
      onClick={onClick}
      style={style}
    >
      {isSubmitting ? (
        <div>
          <PuffLoader color={color} loading={true} cssOverride={override} size={25} />
        </div>
      ) : (
        title
      )}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  &.btn {
    &:focus {
      box-shadow: none;
    }
  }
  &:active {
    box-shadow: 0 0 0 0 rgb(0 0 0 / 50%) !important;
  }
  font-size: 14px;
  font-weight: 500;
  border-radius: 200px;
  padding: 9px 37px;
  &.btn-secondary {
    border-color: ${Colors.newOrage};
    background-color: ${Colors.newOrage};
    color: #fff;
    left: ${(props): string => (props.x ? `${props.x}px` : '0')};
    &:hover {
      background-color: ${Colors.darkRed};
      border-color: ${Colors.darkRed};
      color: '#fff';
    }
    &:active {
      background-color: ${Colors.darkBrown} !important;
      border-color: ${Colors.darkBrown} !important;
    }
  }
  &.btn-primary {
    border-color: ${Colors.darkBrown};
    background-color: ${Colors.darkBrown};
    color: '#fff';
    left: ${(props): string => (props.x ? `${props.x}px` : '0')};
    &:hover {
      background-color: ${Colors.darkRed};
      border-color: ${Colors.darkRed};
      color: #fff;
    }
    &:active {
      background-color: ${Colors.newOrage} !important;
      border-color: ${Colors.newOrage} !important;
    }
  }
`;
